module.exports = __webpack_public_path__ + "static/media/trial1.07fe8341.mp3";